<modal-popup
  [flexible]="true"
  [isOpen]="true"
  (onClose)="onClose.emit([])"
  [title]="'בנק הערות קבועות'"
>
  <div class="body-container t-scrollbar">
    <loader *ngIf="loading"></loader>
    <div *ngIf="!loading" class="notes">
      <checkbox-list
        [selectOne]="false"
        [rows]="notes"
        [selected]="selectedNotes"
        [checkList]="true"
        [emitArray]="true"
        [props]="['text']"
        [displayAs]="'list'"
        [rowPreselectedTest]="rowPreselectedTest"
      ></checkbox-list>
    </div>

    <div class="l-align-end footer">
      <button
        [disabled]="selectedNotes.length == 0"
        (click)="selectNotes()"
        class="t-button--success"
      >
        הוספת הערות
      </button>
    </div>
  </div>
</modal-popup>
